import React,{useContext} from 'react'
import { Container, Row ,Col } from 'react-bootstrap'
import {BsCheckCircle} from 'react-icons/bs'
import PrefixContext from "../../context/PrefixContext.js";

function Index() {

    const PrefixContextData = useContext(PrefixContext);

    return (
        <>
        <section className="new-section d-flex page-heading-margin" id="about">
            <Container className="d-flex">
                <Row className="row d-flex align-content-center">
                    <Col lg="5" md="6">
                        <img src={PrefixContextData.cdnPrefixUrl+"team_3mnomCjXyH.svg"} className="w-100" alt="Our Team"/>
                    </Col>
                    <Col lg="7" md="6">
                        <div className="about-content px-2 px-md-5">
                            <h2 className="text-center section-title">About Us</h2>
                            <h3 className="text-center">We combine intellectual thinking with enthusiastic design to keep your brand engaging</h3>                        
                            <ul>
                                <li className="text-justify">
                                    <BsCheckCircle/>
                                    DevBytes is committed to making your business more efficient, easier to manage and a lot more profitable with customised business solutions.
                                </li>
                                <li className="text-justify">
                                    <BsCheckCircle/>
                                    We specialized in small business web applications that are customised specially for your business yet very affordable.
                                </li>
                                <li className="text-justify">
                                    <BsCheckCircle/>
                                    We here are experts in building the web and mobile products for clients. We help you to fulfil the gap between Development, Design and Product Management.
                                </li>
                                <li className="text-justify">
                                    <BsCheckCircle/>
                                    We provide exceptional consulting expertise and strategic design that compliments your brand and accomplishes your goals.
                                </li>
                                <li className="text-justify">
                                    <BsCheckCircle/>
                                    We have done a lot of work for the Hospitality Industry, Financial, Teaching Institutes and Associations. Since we understand the Business and we have the experience we can create complete solutions or even small modules of Business Functions that can be integrated later.
                                </li>
                            </ul>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
        </>
    )
}

export default Index
